// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SMTPForm-errorMessage-xwzQm {
  margin: 5px 0px;
  display: block;
  color: var(--alert-color);
  font-size: 14px;
  font-weight: normal;
}
.SMTPForm-commonHeaderAdmin-wv3DE {
	position: fixed !important;
}
.SMTPForm-adminLayout-q9O9W {
	padding-top: 64px !important;
}
.SMTPForm-box-rrYbi h2 {
	font-size: 21px;
	font-weight: 600;
}
.SMTPForm-exportLink-_2wAL {
	margin-bottom: -29px;
}
.SMTPForm-blockCenter-BrNdU {
	float: none !important;
	display: block;
	margin: 0 auto;
	margin-top: 30px;
}
.SMTPForm-panelHeader-uC_hJ {
	padding-bottom: 18px !important;
	padding: 24px 15px;
	border-radius: 6px !important;
	border: 1px solid var(--primary-border)
}
.SMTPForm-currencyselect-Nd9Ct {
	width: 100%;
	margin-right: 0px;
}
.SMTPForm-panelHeader-uC_hJ {
	overflow: hidden;
	position: relative;
}
.SMTPForm-mar0-KhjRe {
	margin-left: 0;
	margin-right: 0;
}
@media screen and (max-width: 767px) {
	.SMTPForm-blockCenter-BrNdU {
		padding: 0px;
	}

	.SMTPForm-panelHeader-uC_hJ {
		padding: 24px 5px;
	}
}
/** Admin - Common - Start **/
.SMTPForm-sideAdminPageWrapper-s9Uzk {
	margin-left: var(--siteAdmin-sideBar-width);
	position: relative;
	padding: calc(var(--siteAdmin-header-height) + 28px) 25px 120px;
}
.SMTPForm-panelHeader-uC_hJ {
	border-radius: 0;
	width: 100%;
	display: block;
	font-size: 16px;
	padding-bottom: 12px;
	border-bottom: 1px solid var(--primary-border);
	background-color: var(--background-primary);
}
.SMTPForm-table-bPQhy {
	display: table;
}
.SMTPForm-tableRow-gcGyN {
	display: table-row;
}
.SMTPForm-tableCell-uSTeL {
	display: table-cell;
	float: none;
}
.SMTPForm-formGroup-KVlIF {
	margin-bottom: 6px;
}
.SMTPForm-select-mLM9a {
	position: relative;
	display: inline-block;
	vertical-align: bottom;
	margin-right: 5px;
}
.SMTPForm-noMargin-ZPZ7R {
	margin: 0px;
}
a,
a:hover {
	cursor: pointer;
}
.SMTPForm-exportLink-_2wAL {
	padding-top: 10px;
	padding-right: 10px;
}
.SMTPForm-labelTextNew-n9m57 {
	font-size: 16px;
	line-height: 24px;
	font-weight: 600;
	margin: 0 0 6px;
	text-align: start;
	color: var(--primary-foreground);
}
.SMTPForm-displayInline-zwjwf {
	display: inline-block;
}
/******************* Admin Modal ListSetting Start *******************/
.SMTPForm-btnUPdate-TBd_5 {
	display: inline-block;
}
.SMTPForm-btnModalDelete-hRhrw {
	display: inline-block;
	margin-left: 15px;
}
.SMTPForm-radioBtn-TQaBo {
	position: relative;
	top: 1px;
	vertical-align: middle;
}
.SMTPForm-backgroundImg-ipdwE {
	padding-top: 80%;
	background-position: top center;
	background-size: cover;
}
@media screen and (max-width: 767px) {
	.SMTPForm-btnUPdate-TBd_5 {
		display: block;
		margin-bottom: 12px;
	}

	.SMTPForm-btnModalDelete-hRhrw {
		display: block;
		margin-left: 0px;
	}

	.SMTPForm-btnWidth-M55Xq {
		width: 100%;
	}
}
/******************* Admin Modal ListSetting Start *******************/
/******************* Admin Banner Image Section Start ****************/
.SMTPForm-bannerImageBg-PuVI9 {
	padding-top: 60%;
	background-repeat: no-repeat;
	background-size: contain;
	border-radius: 4px;
	background-position: center;
	background-color: var(--secondary-gray-bg);
	border: 1px dashed var(--primary-border);
}
.SMTPForm-bannerDelete-nsS1Y {
	position: absolute;
	top: -12px;
	right: 4px;
}
/*******************Admin Modal Start **********************/
.SMTPForm-modalRoot-qdAbW {
	padding: 32px;
}
.SMTPForm-modalBorderBottom-q1Hz2 {
	border-bottom: 5px solid var(--primary-bg);
	border-bottom-left-radius: 14px;
	border-bottom-right-radius: 14px;
}
.SMTPForm-logInModalBody-MoB5u {
	padding: 0px;
}
/*************** Admin TableNew Design Start**************************/
.SMTPForm-exportSection-iFFZ1 {
	background: #f5f5f5;
	padding: 24px 15px;
	display: grid;
	grid-template-columns: 28% 15% 55%;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	grid-gap: 11px;
	border-top-left-radius: 6px;
	border-top-right-radius: 6px;
	border: 1px solid var(--primary-border);
	border-bottom: 0;
}
.SMTPForm-exportSectionGridSub-BNKL9 {
	grid-template-columns: 50% 49% !important;
}
.SMTPForm-exportText-GegtJ {
	color: var(--primary-foreground) !important;
	text-decoration: none !important;
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	gap: 12px;
}
.SMTPForm-exportLinkImg-UhmzP {
	background: var(--common-white-primary-bg);
	padding: 10px;
	border-radius: 4px;
	display: inline-block;
}
.SMTPForm-vtrMiddle-JmG1r {
	vertical-align: middle;
}
.SMTPForm-exportImg-u8Sol {
	width: 100%;
	max-width: 16px;
	vertical-align: middle;
}
.SMTPForm-profileViewlabel-RHOE4 {
	display: inline-block;
	width: 38%
}
.SMTPForm-profileViewMainContent-seKaE {
	display: inline-block;
	width: 62%;
}
.SMTPForm-profileViewMain-twEYL {
	border: 1px solid var(--primary-border);
	border-radius: 6px;
}
.SMTPForm-profileViewInner-nDu7P {
	padding: 10px;
	border-bottom: 1px solid var(--primary-border);
}
.SMTPForm-profileImageSection-gI3dA {
	width: 100%;
	height: 100px;
	max-width: 100px;
	max-height: 100px;
	border-radius: 50%;
}
.SMTPForm-lastviewInner-FbeNz {
	padding: 10px;
}
.SMTPForm-whyHostHoriLine-OD_Mq {
	margin: 30px 0;
}
.SMTPForm-tableGrid-Jex8G {
	display: grid;
	grid-template-columns: 50% 50%;
	-webkit-column-gap: 10px;
	   -moz-column-gap: 10px;
	        column-gap: 10px;
	word-wrap: break-word;
}
.SMTPForm-headingContent-MVzFy {
	font-size: 18px;
	font-weight: 500;
}
.SMTPForm-refundTextColor-t5Y_d {
	color: var(--alert-color);
	font-size: 18px;
	text-decoration: line-through;
	text-decoration-thickness: 2px;
	text-decoration-color: var(--black-color);
}
.SMTPForm-dividerLine-WB6Bp {
	border-top: 1px solid var(--primary-border);
	margin: 30px 0;
}
.SMTPForm-smallContent-ji3Sv {
	font-size: 14px;
	margin-top: 6px;
	color: var(--secondary-foreground);
}
@media (max-width: 1200px) and (min-width: 1024px) {
	.SMTPForm-sideAdminPageWrapper-s9Uzk {
		height: 100%;
		overflow: auto;
	}
}
@media (max-width:1199px) {
	.SMTPForm-sideAdminPageWrapper-s9Uzk {
		margin-left: 0;
	}
}
@media screen and (max-width: 991px) {
	.SMTPForm-exportSection-iFFZ1 {
		grid-template-columns: 100%;
	}

	.SMTPForm-exportSectionGridSub-BNKL9 {
		grid-template-columns: 100% !important;
	}

}
@media screen and (max-width: 767px) {
	.SMTPForm-profileViewlabel-RHOE4 {
		width: 100%;
		margin-bottom: 6px;
		text-align: center;
	}

	.SMTPForm-profileViewMainContent-seKaE {
		width: 100%;
		text-align: center;
	}
}
/*************** Admin TableNew Design End**************************/
.SMTPForm-ChangeToUpperCase-krWfy {
	text-transform: uppercase
}
.SMTPForm-noBorder-QPwRo {
	border: 0px !important;
}
/** Admin - Common - End **/
/* site Admin utility Start */
.SMTPForm-siteAdminHeading-NEI0I {
	font-size: 24px;
	line-height: 32px;
	font-weight: 700;
	margin: 0 0 24px;
	text-align: start;
	color: var(--primary-foreground);
}
.SMTPForm-siteAdminSubHeading-3pPsz {
	font-size: 18px;
	line-height: 26px;
	font-weight: 600;
	margin: 0 0 12px;
	text-align: start;
	color: var(--primary-foreground);
}
.SMTPForm-adminFormDivider-gEt6b {
	border-top: 1px solid var(--primary-border);
	margin-bottom: 24px;
}
.SMTPForm-space1-oVqgM {
	margin-bottom: 6px !important;
}
.SMTPForm-space2-vnH8w {
	margin-bottom: 12px !important;
}
.SMTPForm-space3-PvMT7 {
	margin-bottom: 18px !important;
}
.SMTPForm-space4-gmpeG {
	margin-bottom: 24px !important;
}
.SMTPForm-space5-CDpYX {
	margin-bottom: 30px !important;
}
.SMTPForm-space6-kLCSB {
	margin-bottom: 36px !important;
}
.SMTPForm-space7-_i6Eh {
	margin-bottom: 42px !important;
}
.SMTPForm-spaceTop8-q_iwI {
	margin-bottom: 48px !important;
}
.SMTPForm-spaceTop1-L_7Cb {
	margin-top: 6px !important;
}
.SMTPForm-spaceTop2-EbeN5 {
	margin-top: 12px !important;
}
.SMTPForm-spaceTop3-UL8t9 {
	margin-top: 18px !important;
}
.SMTPForm-spaceTop4-Wrcb6 {
	margin-top: 24px !important;
}
.SMTPForm-spaceTop5-WS1N8 {
	margin-top: 30px !important;
}
.SMTPForm-spaceTop6-Aefny {
	margin-top: 36px !important;
}
.SMTPForm-spaceTop7-R_faC {
	margin-top: 42px !important;
}
.SMTPForm-spaceTop8-q_iwI {
	margin-top: 48px !important;
}
.SMTPForm-noMargin-ZPZ7R {
	margin: 0px !important;
}
.SMTPForm-padding1-xz9Ra {
	padding-bottom: 6px !important;
}
.SMTPForm-padding2-AIIjV {
	padding-bottom: 12px !important;
}
.SMTPForm-padding3-zOKsa {
	padding-bottom: 18px !important;
}
.SMTPForm-padding4-Sb2wC {
	padding-bottom: 24px !important;
}
.SMTPForm-padding5-UZn5o {
	padding-bottom: 30px !important;
}
.SMTPForm-padding6-wZT9v {
	padding-bottom: 36px !important;
}
.SMTPForm-padding7-GUTmR {
	padding-bottom: 42px !important;
}
.SMTPForm-paddingTop1-vFHSV {
	padding-top: 6px !important;
}
.SMTPForm-paddingTop2-j3XpL {
	padding-top: 12px !important;
}
.SMTPForm-paddingTop3-RblP_ {
	padding-top: 18px !important;
}
.SMTPForm-paddingTop4-oKeGj {
	padding-top: 24px !important;
}
.SMTPForm-paddingTop5-gh6Ag {
	padding-top: 30px !important;
}
.SMTPForm-paddingTop6-c97za {
	padding-top: 36px !important;
}
.SMTPForm-paddingTop7-gnfr_ {
	padding-top: 42px !important;
}
.SMTPForm-noPadding-CPouF {
	padding: 0px !important;
}
.SMTPForm-textBold-DcV9Y {
	font-weight: 500 !important;
}
.SMTPForm-textBolder-RUp0V {
	font-weight: 700 !important;
}
.SMTPForm-textNormal-eAF60 {
	font-weight: normal !important;
}
.SMTPForm-spaceBottom20-yWUBA {
	margin-bottom: 20px;
}
.SMTPForm-spaceBottom10-GCjZZ {
	margin-bottom: 10px;
}
.SMTPForm-marginNone-zuIku {
	margin: 0;
}
.SMTPForm-spaceBottom15-aUnpV {
	margin-bottom: 15px;
}
.SMTPForm-marginTopNone-F0bXl {
	margin-top: 0;
}
.SMTPForm-spaceTop11-Cn__r {
	margin-top: 11px;
}
.SMTPForm-spaceTop21-Cu61G {
	margin-top: 21px;
}
.SMTPForm-spaceTop20-z_oou {
	margin-top: 20px;
}
.SMTPForm-spaceTop10-OoDqy {
	margin-top: 10px;
}
/*New Design Text Colors */
.SMTPForm-textDarkBlue-Xj7aU {
	color: rgb(20, 39, 94) !important;
}
.SMTPForm-textLightBlue-PmpzJ {
	color: rgb(57, 87, 106) !important;
}
.SMTPForm-textLightSandleGreen-vQ0Nn {
	color: rgb(76, 86, 41) !important;
}
.SMTPForm-textLightBrown-T3zgO {
	color: rgb(115, 79, 33) !important;
}
.SMTPForm-textMediumMaroon-sHShy {
	color: rgb(87, 37, 51) !important;
}
.SMTPForm-textBrown-sGOFh {
	color: rgb(160, 47, 24) !important;
}
.SMTPForm-textMaroon-J_5CK {
	color: rgb(155, 49, 67) !important;
}
.SMTPForm-textDarkBrown-lAe7Z {
	color: rgb(83, 18, 16) !important;
}
.SMTPForm-textMediumBrown-tlnlR {
	color: rgb(142, 28, 10) !important;
}
.SMTPForm-textSkyBlue-cFN04 {
	color: rgb(37, 117, 141) !important;
}
.SMTPForm-textGray-gTBqw {
	color: rgb(77, 65, 51) !important;
}
/** RentAll - Begin **/
.SMTPForm-checkBoxWidth-AjVHY {
  width: 34px;
}
.SMTPForm-textWidth-Jt0z_ {
  width: 88%;
  vertical-align: middle;
  font-size: 16px;
}`, "",{"version":3,"sources":["webpack://./src/components/utils.css","webpack://./src/components/siteadmin/newcommonstyle.css","webpack://./src/components/siteadmin/admin-common.css","webpack://./src/components/helpers.css","webpack://./src/components/siteadmin/SMTPManagement/SMTPForm/SMTPForm.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,cAAc;EACd,yBAAyB;EACzB,eAAe;EACf,mBAAmB;AACrB;ACNA;CACC,0BAA0B;AAC3B;AAEA;CACC,4BAA4B;AAC7B;AAEA;CACC,eAAe;CACf,gBAAgB;AACjB;AAEA;CACC,oBAAoB;AACrB;AAEA;CACC,sBAAsB;CACtB,cAAc;CACd,cAAc;CACd,gBAAgB;AACjB;AAEA;CACC,+BAA+B;CAC/B,kBAAkB;CAClB,6BAA6B;CAC7B;AACD;AAEA;CACC,WAAW;CACX,iBAAiB;AAClB;AAEA;CACC,gBAAgB;CAChB,kBAAkB;AACnB;AAEA;CACC,cAAc;CACd,eAAe;AAChB;AAEA;CACC;EACC,YAAY;CACb;;CAEA;EACC,iBAAiB;CAClB;AACD;ACpDA,6BAA6B;AAC7B;CACC,2CAA2C;CAC3C,kBAAkB;CAClB,+DAA+D;AAChE;AAEA;CACC,gBAAgB;CAChB,WAAW;CACX,cAAc;CACd,eAAe;CACf,oBAAoB;CACpB,8CAA8C;CAC9C,2CAA2C;AAC5C;AAEA;CACC,cAAc;AACf;AAEA;CACC,kBAAkB;AACnB;AAEA;CACC,mBAAmB;CACnB,WAAW;AACZ;AAEA;CACC,kBAAkB;AACnB;AAEA;CACC,kBAAkB;CAClB,qBAAqB;CACrB,sBAAsB;CACtB,iBAAiB;AAClB;AAEA;CACC,WAAW;AACZ;AAEA;;CAEC,eAAe;AAChB;AAEA;CACC,iBAAiB;CACjB,mBAAmB;AACpB;AAEA;CACC,eAAe;CACf,iBAAiB;CACjB,gBAAgB;CAChB,eAAe;CACf,iBAAiB;CACjB,gCAAgC;AACjC;AAEA;CACC,qBAAqB;AACtB;AAEA,sEAAsE;AAEtE;CACC,qBAAqB;AACtB;AAEA;CACC,qBAAqB;CACrB,iBAAiB;AAClB;AAEA;CACC,kBAAkB;CAClB,QAAQ;CACR,sBAAsB;AACvB;AAEA;CACC,gBAAgB;CAChB,+BAA+B;CAC/B,sBAAsB;AACvB;AAEA;CACC;EACC,cAAc;EACd,mBAAmB;CACpB;;CAEA;EACC,cAAc;EACd,gBAAgB;CACjB;;CAEA;EACC,WAAW;CACZ;AACD;AAEA,sEAAsE;AAEtE,sEAAsE;AAEtE;CACC,gBAAgB;CAChB,4BAA4B;CAC5B,wBAAwB;CACxB,kBAAkB;CAClB,2BAA2B;CAC3B,0CAA0C;CAC1C,wCAAwC;AACzC;AAEA;CACC,kBAAkB;CAClB,UAAU;CACV,UAAU;AACX;AAEA,4DAA4D;AAE5D;CACC,aAAa;AACd;AAEA;CACC,0CAA0C;CAC1C,+BAA+B;CAC/B,gCAAgC;AACjC;AAEA;CACC,YAAY;AACb;AAEA,sEAAsE;AAEtE;CACC,mBAAmB;CACnB,kBAAkB;CAClB,aAAa;CACb,kCAAkC;CAClC,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,cAAc;CACd,2BAA2B;CAC3B,4BAA4B;CAC5B,uCAAuC;CACvC,gBAAgB;AACjB;AAEA;CACC,yCAAyC;AAC1C;AAEA;CACC,2CAA2C;CAC3C,gCAAgC;CAChC,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,SAAS;AACV;AAEA;CACC,0CAA0C;CAC1C,aAAa;CACb,kBAAkB;CAClB,qBAAqB;AACtB;AAEA;CACC,sBAAsB;AACvB;AAEA;CACC,WAAW;CACX,eAAe;CACf,sBAAsB;AACvB;AAEA;CACC,qBAAqB;CACrB;AACD;AAEA;CACC,qBAAqB;CACrB,UAAU;AACX;AAEA;CACC,uCAAuC;CACvC,kBAAkB;AACnB;AAEA;CACC,aAAa;CACb,8CAA8C;AAC/C;AAEA;CACC,WAAW;CACX,aAAa;CACb,gBAAgB;CAChB,iBAAiB;CACjB,kBAAkB;AACnB;AAEA;CACC,aAAa;AACd;AAEA;CACC,cAAc;AACf;AAEA;CACC,aAAa;CACb,8BAA8B;CAC9B,wBAAgB;IAAhB,qBAAgB;SAAhB,gBAAgB;CAChB,qBAAqB;AACtB;AAEA;CACC,eAAe;CACf,gBAAgB;AACjB;AAEA;CACC,yBAAyB;CACzB,eAAe;CACf,6BAA6B;CAC7B,8BAA8B;CAC9B,yCAAyC;AAC1C;AAEA;CACC,2CAA2C;CAC3C,cAAc;AACf;AAEA;CACC,eAAe;CACf,eAAe;CACf,kCAAkC;AACnC;AAEA;CACC;EACC,YAAY;EACZ,cAAc;CACf;AACD;AAEA;CACC;EACC,cAAc;CACf;AACD;AAEA;CACC;EACC,2BAA2B;CAC5B;;CAEA;EACC,sCAAsC;CACvC;;AAED;AAEA;CACC;EACC,WAAW;EACX,kBAAkB;EAClB,kBAAkB;CACnB;;CAEA;EACC,WAAW;EACX,kBAAkB;CACnB;AACD;AAEA,oEAAoE;AAEpE;CACC;AACD;AAEA;CACC,sBAAsB;AACvB;AAEA,2BAA2B;AAE3B,6BAA6B;AAC7B;CACC,eAAe;CACf,iBAAiB;CACjB,gBAAgB;CAChB,gBAAgB;CAChB,iBAAiB;CACjB,gCAAgC;AACjC;AAEA;CACC,eAAe;CACf,iBAAiB;CACjB,gBAAgB;CAChB,gBAAgB;CAChB,iBAAiB;CACjB,gCAAgC;AACjC;AAEA;CACC,2CAA2C;CAC3C,mBAAmB;AACpB;ACvUA;CACC,6BAA6B;AAC9B;AAEA;CACC,8BAA8B;AAC/B;AAEA;CACC,8BAA8B;AAC/B;AAEA;CACC,8BAA8B;AAC/B;AAEA;CACC,8BAA8B;AAC/B;AAEA;CACC,8BAA8B;AAC/B;AAEA;CACC,8BAA8B;AAC/B;AAEA;CACC,8BAA8B;AAC/B;AAEA;CACC,0BAA0B;AAC3B;AAEA;CACC,2BAA2B;AAC5B;AAEA;CACC,2BAA2B;AAC5B;AAEA;CACC,2BAA2B;AAC5B;AAEA;CACC,2BAA2B;AAC5B;AAEA;CACC,2BAA2B;AAC5B;AAEA;CACC,2BAA2B;AAC5B;AAEA;CACC,2BAA2B;AAC5B;AAEA;CACC,sBAAsB;AACvB;AAEA;CACC,8BAA8B;AAC/B;AAEA;CACC,+BAA+B;AAChC;AAEA;CACC,+BAA+B;AAChC;AAEA;CACC,+BAA+B;AAChC;AAEA;CACC,+BAA+B;AAChC;AAEA;CACC,+BAA+B;AAChC;AAEA;CACC,+BAA+B;AAChC;AAEA;CACC,2BAA2B;AAC5B;AAEA;CACC,4BAA4B;AAC7B;AAEA;CACC,4BAA4B;AAC7B;AAEA;CACC,4BAA4B;AAC7B;AAEA;CACC,4BAA4B;AAC7B;AAEA;CACC,4BAA4B;AAC7B;AAEA;CACC,4BAA4B;AAC7B;AAEA;CACC,uBAAuB;AACxB;AAEA;CACC,2BAA2B;AAC5B;AAEA;CACC,2BAA2B;AAC5B;AAEA;CACC,8BAA8B;AAC/B;AAEA;CACC,mBAAmB;AACpB;AAEA;CACC,mBAAmB;AACpB;AAEA;CACC,SAAS;AACV;AAEA;CACC,mBAAmB;AACpB;AAEA;CACC,aAAa;AACd;AAEA;CACC,gBAAgB;AACjB;AAEA;CACC,gBAAgB;AACjB;AAEA;CACC,gBAAgB;AACjB;AAEA;CACC,gBAAgB;AACjB;AAEA,0BAA0B;AAE1B;CACC,iCAAiC;AAClC;AAEA;CACC,kCAAkC;AACnC;AAEA;CACC,iCAAiC;AAClC;AAEA;CACC,kCAAkC;AACnC;AAEA;CACC,iCAAiC;AAClC;AAEA;CACC,kCAAkC;AACnC;AAEA;CACC,kCAAkC;AACnC;AAEA;CACC,iCAAiC;AAClC;AAEA;CACC,kCAAkC;AACnC;AAEA;CACC,mCAAmC;AACpC;AAEA;CACC,iCAAiC;AAClC;ACxNA,sBAAsB;AACtB;EACE,WAAW;AACb;AAEA;EACE,UAAU;EACV,sBAAsB;EACtB,eAAe;AACjB","sourcesContent":[".errorMessage {\n  margin: 5px 0px;\n  display: block;\n  color: var(--alert-color);\n  font-size: 14px;\n  font-weight: normal;\n}",".commonHeaderAdmin {\n\tposition: fixed !important;\n}\n\n.adminLayout {\n\tpadding-top: 64px !important;\n}\n\n.box h2 {\n\tfont-size: 21px;\n\tfont-weight: 600;\n}\n\n.exportLink {\n\tmargin-bottom: -29px;\n}\n\n.blockCenter {\n\tfloat: none !important;\n\tdisplay: block;\n\tmargin: 0 auto;\n\tmargin-top: 30px;\n}\n\n.panelHeader {\n\tpadding-bottom: 18px !important;\n\tpadding: 24px 15px;\n\tborder-radius: 6px !important;\n\tborder: 1px solid var(--primary-border)\n}\n\n.currencyselect {\n\twidth: 100%;\n\tmargin-right: 0px;\n}\n\n.panelHeader {\n\toverflow: hidden;\n\tposition: relative;\n}\n\n.mar0 {\n\tmargin-left: 0;\n\tmargin-right: 0;\n}\n\n@media screen and (max-width: 767px) {\n\t.blockCenter {\n\t\tpadding: 0px;\n\t}\n\n\t.panelHeader {\n\t\tpadding: 24px 5px;\n\t}\n}","@import './newcommonstyle.css';\n\n/** Admin - Common - Start **/\n.sideAdminPageWrapper {\n\tmargin-left: var(--siteAdmin-sideBar-width);\n\tposition: relative;\n\tpadding: calc(var(--siteAdmin-header-height) + 28px) 25px 120px;\n}\n\n.panelHeader {\n\tborder-radius: 0;\n\twidth: 100%;\n\tdisplay: block;\n\tfont-size: 16px;\n\tpadding-bottom: 12px;\n\tborder-bottom: 1px solid var(--primary-border);\n\tbackground-color: var(--background-primary);\n}\n\n.table {\n\tdisplay: table;\n}\n\n.tableRow {\n\tdisplay: table-row;\n}\n\n.tableCell {\n\tdisplay: table-cell;\n\tfloat: none;\n}\n\n.formGroup {\n\tmargin-bottom: 6px;\n}\n\n.select {\n\tposition: relative;\n\tdisplay: inline-block;\n\tvertical-align: bottom;\n\tmargin-right: 5px;\n}\n\n.noMargin {\n\tmargin: 0px;\n}\n\na,\na:hover {\n\tcursor: pointer;\n}\n\n.exportLink {\n\tpadding-top: 10px;\n\tpadding-right: 10px;\n}\n\n.labelTextNew {\n\tfont-size: 16px;\n\tline-height: 24px;\n\tfont-weight: 600;\n\tmargin: 0 0 6px;\n\ttext-align: start;\n\tcolor: var(--primary-foreground);\n}\n\n.displayInline {\n\tdisplay: inline-block;\n}\n\n/******************* Admin Modal ListSetting Start *******************/\n\n.btnUPdate {\n\tdisplay: inline-block;\n}\n\n.btnModalDelete {\n\tdisplay: inline-block;\n\tmargin-left: 15px;\n}\n\n.radioBtn {\n\tposition: relative;\n\ttop: 1px;\n\tvertical-align: middle;\n}\n\n.backgroundImg {\n\tpadding-top: 80%;\n\tbackground-position: top center;\n\tbackground-size: cover;\n}\n\n@media screen and (max-width: 767px) {\n\t.btnUPdate {\n\t\tdisplay: block;\n\t\tmargin-bottom: 12px;\n\t}\n\n\t.btnModalDelete {\n\t\tdisplay: block;\n\t\tmargin-left: 0px;\n\t}\n\n\t.btnWidth {\n\t\twidth: 100%;\n\t}\n}\n\n/******************* Admin Modal ListSetting Start *******************/\n\n/******************* Admin Banner Image Section Start ****************/\n\n.bannerImageBg {\n\tpadding-top: 60%;\n\tbackground-repeat: no-repeat;\n\tbackground-size: contain;\n\tborder-radius: 4px;\n\tbackground-position: center;\n\tbackground-color: var(--secondary-gray-bg);\n\tborder: 1px dashed var(--primary-border);\n}\n\n.bannerDelete {\n\tposition: absolute;\n\ttop: -12px;\n\tright: 4px;\n}\n\n/*******************Admin Modal Start **********************/\n\n.modalRoot {\n\tpadding: 32px;\n}\n\n.modalBorderBottom {\n\tborder-bottom: 5px solid var(--primary-bg);\n\tborder-bottom-left-radius: 14px;\n\tborder-bottom-right-radius: 14px;\n}\n\n.logInModalBody {\n\tpadding: 0px;\n}\n\n/*************** Admin TableNew Design Start**************************/\n\n.exportSection {\n\tbackground: #f5f5f5;\n\tpadding: 24px 15px;\n\tdisplay: grid;\n\tgrid-template-columns: 28% 15% 55%;\n\talign-items: center;\n\tgrid-gap: 11px;\n\tborder-top-left-radius: 6px;\n\tborder-top-right-radius: 6px;\n\tborder: 1px solid var(--primary-border);\n\tborder-bottom: 0;\n}\n\n.exportSectionGridSub {\n\tgrid-template-columns: 50% 49% !important;\n}\n\n.exportText {\n\tcolor: var(--primary-foreground) !important;\n\ttext-decoration: none !important;\n\tdisplay: flex;\n\talign-items: center;\n\tgap: 12px;\n}\n\n.exportLinkImg {\n\tbackground: var(--common-white-primary-bg);\n\tpadding: 10px;\n\tborder-radius: 4px;\n\tdisplay: inline-block;\n}\n\n.vtrMiddle {\n\tvertical-align: middle;\n}\n\n.exportImg {\n\twidth: 100%;\n\tmax-width: 16px;\n\tvertical-align: middle;\n}\n\n.profileViewlabel {\n\tdisplay: inline-block;\n\twidth: 38%\n}\n\n.profileViewMainContent {\n\tdisplay: inline-block;\n\twidth: 62%;\n}\n\n.profileViewMain {\n\tborder: 1px solid var(--primary-border);\n\tborder-radius: 6px;\n}\n\n.profileViewInner {\n\tpadding: 10px;\n\tborder-bottom: 1px solid var(--primary-border);\n}\n\n.profileImageSection {\n\twidth: 100%;\n\theight: 100px;\n\tmax-width: 100px;\n\tmax-height: 100px;\n\tborder-radius: 50%;\n}\n\n.lastviewInner {\n\tpadding: 10px;\n}\n\n.whyHostHoriLine {\n\tmargin: 30px 0;\n}\n\n.tableGrid {\n\tdisplay: grid;\n\tgrid-template-columns: 50% 50%;\n\tcolumn-gap: 10px;\n\tword-wrap: break-word;\n}\n\n.headingContent {\n\tfont-size: 18px;\n\tfont-weight: 500;\n}\n\n.refundTextColor {\n\tcolor: var(--alert-color);\n\tfont-size: 18px;\n\ttext-decoration: line-through;\n\ttext-decoration-thickness: 2px;\n\ttext-decoration-color: var(--black-color);\n}\n\n.dividerLine {\n\tborder-top: 1px solid var(--primary-border);\n\tmargin: 30px 0;\n}\n\n.smallContent {\n\tfont-size: 14px;\n\tmargin-top: 6px;\n\tcolor: var(--secondary-foreground);\n}\n\n@media (max-width: 1200px) and (min-width: 1024px) {\n\t.sideAdminPageWrapper {\n\t\theight: 100%;\n\t\toverflow: auto;\n\t}\n}\n\n@media (max-width:1199px) {\n\t.sideAdminPageWrapper {\n\t\tmargin-left: 0;\n\t}\n}\n\n@media screen and (max-width: 991px) {\n\t.exportSection {\n\t\tgrid-template-columns: 100%;\n\t}\n\n\t.exportSectionGridSub {\n\t\tgrid-template-columns: 100% !important;\n\t}\n\n}\n\n@media screen and (max-width: 767px) {\n\t.profileViewlabel {\n\t\twidth: 100%;\n\t\tmargin-bottom: 6px;\n\t\ttext-align: center;\n\t}\n\n\t.profileViewMainContent {\n\t\twidth: 100%;\n\t\ttext-align: center;\n\t}\n}\n\n/*************** Admin TableNew Design End**************************/\n\n.ChangeToUpperCase {\n\ttext-transform: uppercase\n}\n\n.noBorder {\n\tborder: 0px !important;\n}\n\n/** Admin - Common - End **/\n\n/* site Admin utility Start */\n.siteAdminHeading {\n\tfont-size: 24px;\n\tline-height: 32px;\n\tfont-weight: 700;\n\tmargin: 0 0 24px;\n\ttext-align: start;\n\tcolor: var(--primary-foreground);\n}\n\n.siteAdminSubHeading {\n\tfont-size: 18px;\n\tline-height: 26px;\n\tfont-weight: 600;\n\tmargin: 0 0 12px;\n\ttext-align: start;\n\tcolor: var(--primary-foreground);\n}\n\n.adminFormDivider {\n\tborder-top: 1px solid var(--primary-border);\n\tmargin-bottom: 24px;\n}",".space1 {\n\tmargin-bottom: 6px !important;\n}\n\n.space2 {\n\tmargin-bottom: 12px !important;\n}\n\n.space3 {\n\tmargin-bottom: 18px !important;\n}\n\n.space4 {\n\tmargin-bottom: 24px !important;\n}\n\n.space5 {\n\tmargin-bottom: 30px !important;\n}\n\n.space6 {\n\tmargin-bottom: 36px !important;\n}\n\n.space7 {\n\tmargin-bottom: 42px !important;\n}\n\n.spaceTop8 {\n\tmargin-bottom: 48px !important;\n}\n\n.spaceTop1 {\n\tmargin-top: 6px !important;\n}\n\n.spaceTop2 {\n\tmargin-top: 12px !important;\n}\n\n.spaceTop3 {\n\tmargin-top: 18px !important;\n}\n\n.spaceTop4 {\n\tmargin-top: 24px !important;\n}\n\n.spaceTop5 {\n\tmargin-top: 30px !important;\n}\n\n.spaceTop6 {\n\tmargin-top: 36px !important;\n}\n\n.spaceTop7 {\n\tmargin-top: 42px !important;\n}\n\n.spaceTop8 {\n\tmargin-top: 48px !important;\n}\n\n.noMargin {\n\tmargin: 0px !important;\n}\n\n.padding1 {\n\tpadding-bottom: 6px !important;\n}\n\n.padding2 {\n\tpadding-bottom: 12px !important;\n}\n\n.padding3 {\n\tpadding-bottom: 18px !important;\n}\n\n.padding4 {\n\tpadding-bottom: 24px !important;\n}\n\n.padding5 {\n\tpadding-bottom: 30px !important;\n}\n\n.padding6 {\n\tpadding-bottom: 36px !important;\n}\n\n.padding7 {\n\tpadding-bottom: 42px !important;\n}\n\n.paddingTop1 {\n\tpadding-top: 6px !important;\n}\n\n.paddingTop2 {\n\tpadding-top: 12px !important;\n}\n\n.paddingTop3 {\n\tpadding-top: 18px !important;\n}\n\n.paddingTop4 {\n\tpadding-top: 24px !important;\n}\n\n.paddingTop5 {\n\tpadding-top: 30px !important;\n}\n\n.paddingTop6 {\n\tpadding-top: 36px !important;\n}\n\n.paddingTop7 {\n\tpadding-top: 42px !important;\n}\n\n.noPadding {\n\tpadding: 0px !important;\n}\n\n.textBold {\n\tfont-weight: 500 !important;\n}\n\n.textBolder {\n\tfont-weight: 700 !important;\n}\n\n.textNormal {\n\tfont-weight: normal !important;\n}\n\n.spaceBottom20 {\n\tmargin-bottom: 20px;\n}\n\n.spaceBottom10 {\n\tmargin-bottom: 10px;\n}\n\n.marginNone {\n\tmargin: 0;\n}\n\n.spaceBottom15 {\n\tmargin-bottom: 15px;\n}\n\n.marginTopNone {\n\tmargin-top: 0;\n}\n\n.spaceTop11 {\n\tmargin-top: 11px;\n}\n\n.spaceTop21 {\n\tmargin-top: 21px;\n}\n\n.spaceTop20 {\n\tmargin-top: 20px;\n}\n\n.spaceTop10 {\n\tmargin-top: 10px;\n}\n\n/*New Design Text Colors */\n\n.textDarkBlue {\n\tcolor: rgb(20, 39, 94) !important;\n}\n\n.textLightBlue {\n\tcolor: rgb(57, 87, 106) !important;\n}\n\n.textLightSandleGreen {\n\tcolor: rgb(76, 86, 41) !important;\n}\n\n.textLightBrown {\n\tcolor: rgb(115, 79, 33) !important;\n}\n\n.textMediumMaroon {\n\tcolor: rgb(87, 37, 51) !important;\n}\n\n.textBrown {\n\tcolor: rgb(160, 47, 24) !important;\n}\n\n.textMaroon {\n\tcolor: rgb(155, 49, 67) !important;\n}\n\n.textDarkBrown {\n\tcolor: rgb(83, 18, 16) !important;\n}\n\n.textMediumBrown {\n\tcolor: rgb(142, 28, 10) !important;\n}\n\n.textSkyBlue {\n\tcolor: rgb(37, 117, 141) !important;\n}\n\n.textGray {\n\tcolor: rgb(77, 65, 51) !important;\n}","@import '../../../utils.css';\n@import '../../admin-common.css';\n@import '../../../helpers.css';\n\n/** RentAll - Begin **/\n.checkBoxWidth {\n  width: 34px;\n}\n\n.textWidth {\n  width: 88%;\n  vertical-align: middle;\n  font-size: 16px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"errorMessage": `SMTPForm-errorMessage-xwzQm`,
	"commonHeaderAdmin": `SMTPForm-commonHeaderAdmin-wv3DE`,
	"adminLayout": `SMTPForm-adminLayout-q9O9W`,
	"box": `SMTPForm-box-rrYbi`,
	"exportLink": `SMTPForm-exportLink-_2wAL`,
	"blockCenter": `SMTPForm-blockCenter-BrNdU`,
	"panelHeader": `SMTPForm-panelHeader-uC_hJ`,
	"currencyselect": `SMTPForm-currencyselect-Nd9Ct`,
	"mar0": `SMTPForm-mar0-KhjRe`,
	"sideAdminPageWrapper": `SMTPForm-sideAdminPageWrapper-s9Uzk`,
	"table": `SMTPForm-table-bPQhy`,
	"tableRow": `SMTPForm-tableRow-gcGyN`,
	"tableCell": `SMTPForm-tableCell-uSTeL`,
	"formGroup": `SMTPForm-formGroup-KVlIF`,
	"select": `SMTPForm-select-mLM9a`,
	"noMargin": `SMTPForm-noMargin-ZPZ7R`,
	"labelTextNew": `SMTPForm-labelTextNew-n9m57`,
	"displayInline": `SMTPForm-displayInline-zwjwf`,
	"btnUPdate": `SMTPForm-btnUPdate-TBd_5`,
	"btnModalDelete": `SMTPForm-btnModalDelete-hRhrw`,
	"radioBtn": `SMTPForm-radioBtn-TQaBo`,
	"backgroundImg": `SMTPForm-backgroundImg-ipdwE`,
	"btnWidth": `SMTPForm-btnWidth-M55Xq`,
	"bannerImageBg": `SMTPForm-bannerImageBg-PuVI9`,
	"bannerDelete": `SMTPForm-bannerDelete-nsS1Y`,
	"modalRoot": `SMTPForm-modalRoot-qdAbW`,
	"modalBorderBottom": `SMTPForm-modalBorderBottom-q1Hz2`,
	"logInModalBody": `SMTPForm-logInModalBody-MoB5u`,
	"exportSection": `SMTPForm-exportSection-iFFZ1`,
	"exportSectionGridSub": `SMTPForm-exportSectionGridSub-BNKL9`,
	"exportText": `SMTPForm-exportText-GegtJ`,
	"exportLinkImg": `SMTPForm-exportLinkImg-UhmzP`,
	"vtrMiddle": `SMTPForm-vtrMiddle-JmG1r`,
	"exportImg": `SMTPForm-exportImg-u8Sol`,
	"profileViewlabel": `SMTPForm-profileViewlabel-RHOE4`,
	"profileViewMainContent": `SMTPForm-profileViewMainContent-seKaE`,
	"profileViewMain": `SMTPForm-profileViewMain-twEYL`,
	"profileViewInner": `SMTPForm-profileViewInner-nDu7P`,
	"profileImageSection": `SMTPForm-profileImageSection-gI3dA`,
	"lastviewInner": `SMTPForm-lastviewInner-FbeNz`,
	"whyHostHoriLine": `SMTPForm-whyHostHoriLine-OD_Mq`,
	"tableGrid": `SMTPForm-tableGrid-Jex8G`,
	"headingContent": `SMTPForm-headingContent-MVzFy`,
	"refundTextColor": `SMTPForm-refundTextColor-t5Y_d`,
	"dividerLine": `SMTPForm-dividerLine-WB6Bp`,
	"smallContent": `SMTPForm-smallContent-ji3Sv`,
	"ChangeToUpperCase": `SMTPForm-ChangeToUpperCase-krWfy`,
	"noBorder": `SMTPForm-noBorder-QPwRo`,
	"siteAdminHeading": `SMTPForm-siteAdminHeading-NEI0I`,
	"siteAdminSubHeading": `SMTPForm-siteAdminSubHeading-3pPsz`,
	"adminFormDivider": `SMTPForm-adminFormDivider-gEt6b`,
	"space1": `SMTPForm-space1-oVqgM`,
	"space2": `SMTPForm-space2-vnH8w`,
	"space3": `SMTPForm-space3-PvMT7`,
	"space4": `SMTPForm-space4-gmpeG`,
	"space5": `SMTPForm-space5-CDpYX`,
	"space6": `SMTPForm-space6-kLCSB`,
	"space7": `SMTPForm-space7-_i6Eh`,
	"spaceTop8": `SMTPForm-spaceTop8-q_iwI`,
	"spaceTop1": `SMTPForm-spaceTop1-L_7Cb`,
	"spaceTop2": `SMTPForm-spaceTop2-EbeN5`,
	"spaceTop3": `SMTPForm-spaceTop3-UL8t9`,
	"spaceTop4": `SMTPForm-spaceTop4-Wrcb6`,
	"spaceTop5": `SMTPForm-spaceTop5-WS1N8`,
	"spaceTop6": `SMTPForm-spaceTop6-Aefny`,
	"spaceTop7": `SMTPForm-spaceTop7-R_faC`,
	"padding1": `SMTPForm-padding1-xz9Ra`,
	"padding2": `SMTPForm-padding2-AIIjV`,
	"padding3": `SMTPForm-padding3-zOKsa`,
	"padding4": `SMTPForm-padding4-Sb2wC`,
	"padding5": `SMTPForm-padding5-UZn5o`,
	"padding6": `SMTPForm-padding6-wZT9v`,
	"padding7": `SMTPForm-padding7-GUTmR`,
	"paddingTop1": `SMTPForm-paddingTop1-vFHSV`,
	"paddingTop2": `SMTPForm-paddingTop2-j3XpL`,
	"paddingTop3": `SMTPForm-paddingTop3-RblP_`,
	"paddingTop4": `SMTPForm-paddingTop4-oKeGj`,
	"paddingTop5": `SMTPForm-paddingTop5-gh6Ag`,
	"paddingTop6": `SMTPForm-paddingTop6-c97za`,
	"paddingTop7": `SMTPForm-paddingTop7-gnfr_`,
	"noPadding": `SMTPForm-noPadding-CPouF`,
	"textBold": `SMTPForm-textBold-DcV9Y`,
	"textBolder": `SMTPForm-textBolder-RUp0V`,
	"textNormal": `SMTPForm-textNormal-eAF60`,
	"spaceBottom20": `SMTPForm-spaceBottom20-yWUBA`,
	"spaceBottom10": `SMTPForm-spaceBottom10-GCjZZ`,
	"marginNone": `SMTPForm-marginNone-zuIku`,
	"spaceBottom15": `SMTPForm-spaceBottom15-aUnpV`,
	"marginTopNone": `SMTPForm-marginTopNone-F0bXl`,
	"spaceTop11": `SMTPForm-spaceTop11-Cn__r`,
	"spaceTop21": `SMTPForm-spaceTop21-Cu61G`,
	"spaceTop20": `SMTPForm-spaceTop20-z_oou`,
	"spaceTop10": `SMTPForm-spaceTop10-OoDqy`,
	"textDarkBlue": `SMTPForm-textDarkBlue-Xj7aU`,
	"textLightBlue": `SMTPForm-textLightBlue-PmpzJ`,
	"textLightSandleGreen": `SMTPForm-textLightSandleGreen-vQ0Nn`,
	"textLightBrown": `SMTPForm-textLightBrown-T3zgO`,
	"textMediumMaroon": `SMTPForm-textMediumMaroon-sHShy`,
	"textBrown": `SMTPForm-textBrown-sGOFh`,
	"textMaroon": `SMTPForm-textMaroon-J_5CK`,
	"textDarkBrown": `SMTPForm-textDarkBrown-lAe7Z`,
	"textMediumBrown": `SMTPForm-textMediumBrown-tlnlR`,
	"textSkyBlue": `SMTPForm-textSkyBlue-cFN04`,
	"textGray": `SMTPForm-textGray-gTBqw`,
	"checkBoxWidth": `SMTPForm-checkBoxWidth-AjVHY`,
	"textWidth": `SMTPForm-textWidth-Jt0z_`
};
module.exports = ___CSS_LOADER_EXPORT___;
